module.exports = __webpack_public_path__ + "static/media/TP_CC (Lauan).d2e480a0.png";